var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "site-link",
    {
      staticClass: "card category-card display-flex flex-column align-around",
      staticStyle: { "--card-margin-bottom": "0" },
      attrs: { to: _vm.$category({ name: _vm.category.id }) },
      nativeOn: {
        click: function ($event) {
          return _vm.$posthog.capture("icons_landing:category_link_click", {
            category: _vm.category.id,
          })
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "padding-y-sm" },
        [
          _vm._t("visuals", function () {
            return [
              _c("i", { class: `fas fa-${_vm.category.icon} fa-fw size-3xl` }),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "size-xs text-uppercase",
          staticStyle: {
            "font-weight": "var(--font-weight-bold)",
            hyphens: "auto",
            "letter-spacing": "var(--letter-spacing-2xl)",
            "line-height": "var(--line-height-sm)",
            "overflow-x": "clip",
            "text-overflow": "ellipsis",
          },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.category.label)),
          _c("span", { staticClass: "sr-only" }, [_vm._v(" icons")]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }